<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Raport anulari"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="Tip anulare">
                <el-select class="full-width" v-model="Filters.TipAnulare" size="small">
                  <el-option label="Toate"   value="-1"></el-option>
                  <el-option label="Client"    value="Client"></el-option>
                  <el-option label="Frontend" value="Frontend"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Centru productie' >
                  <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable size="small">
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id" :label='item.Nume' :value='item.Id'/>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Client">
                <el-select class="full-width" v-model="Filters.IdClient" filterable size="small">
                  <el-option label="Toti"   value="-1"></el-option>
                  <el-option
                    v-for="item in Info.clienti"
                    :key="'clienti' + item.Id"
                    :label="item.Nume"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label="Numar inmatriculare">
                <el-input v-model="Filters.Numar" size="small" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Interval'>
                <br>
                <el-date-picker
                    v-model="Filters.Data"
                    type="daterange" size="small"
                    range-separator="-"
                    start-placeholder="Data inceput"
                    end-placeholder="Data sfarsit"
                    :picker-options="datePickerOptions"
                    format="dd/MM/yyyy" value-format="yyyy-MM-dd" >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()" size="small"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()" size="small">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table el-table :data="Results">
      <el-table-column prop="Id" label="#"></el-table-column>
      <el-table-column label="Data rezervarii">
        <template slot-scope="scope">
          {{ scope.row.DataRezervarii | DataOraFaraSec() }}
        </template> 
      </el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="NumeCentru" label="Centru productie"></el-table-column>
      <el-table-column prop="Client" label="Client"></el-table-column>
      <el-table-column prop="Anulata" label="Tip anulare" ></el-table-column>
      <el-table-column label="Data anularii">
        <template slot-scope="scope">
          {{ scope.row.DataAnulare | DataOraFaraSec() }}
           <!-- {{scope.row.DataAnularii}} -->
        </template> 
      </el-table-column>
      <el-table-column prop="UtilizatorAnulare" label="Utilizator"></el-table-column>
      <el-table-column prop="MotivulAnularii" label="Motiv"></el-table-column>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "raport_anulari",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
      },
      Filters: {
        TipAnulare: "-1",
        Data: [],
        Numar: "",
        IdClient: "-1",
        IdCentruProductie: "-1",
      },
      OrderBy: {'Id': 'DESC'},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async get_info() {
      var response = await this.post("admin/raport_anulari/get_info");
      this.Info.clienti = response.clienti;
      this.Info.centre_productie = response.centre_productie;
      // this.Info.utilizatori = response.utilizatori;
      // if (this.Filters.IdUser.length > 0)
      //   this.Filters.IdUser = this.Info.utilizatori[0].Id;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/raport_anulari/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("actiuni");
    },
    reset() {
      this.Filters = {
        TipAnulare: "-1",
        Data: [],
        Numar: "",
        IdClient: "-1",
        IdCentruProductie: "-1",
      };
      this.refresh_info();
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right('Management')){
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 18%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
